/// <reference path="../app.js"/>

class FacebookBehaviour {
	static init() {
		if ($(".SMFeedElement").length > 0) {
			$.get("/ajax/getFacebookPosts", html => {
				$(".SMFeedElement .carousel").each((index, element) => {
					if (html.length > 0) {
						$(element).html(html);
						$(element).find(".message").each(function() {
							$(this).html($(this).html().replace(/(http|https):\/\/[.\S]+/g, (substr) => `<a href="${substr}">${substr}</a>`));
						});

						$(element).slick({
							variableWidth: true,
							prevArrow: null,
							autoplaySpeed: 5000,
							autoplay: true,
							nextArrow: "<div class=\"next\"><span>Next <i class=\"fal fa-arrow-right\"></i></span></div>"
						});
					} else {
						$(element).html(`<a title="There was an error; check the Facebook API requests" href="${$(".social-icon.facebook").first().attr("href")}">Visit our Facebook page!</a>`);
					}
				});
			});
		}
	}
}